import { Outlet, useLocation } from 'react-router-dom';
import PayBills from './PayBills';
import { PayBillsHubProvider } from './PayBillsHubContext';

const BILL_OVERLAY_PATTERN = /^\/pay-bills\/bill\//;

const PayBillsLayout = () => {
  const { pathname } = useLocation();
  const overlayOpen = BILL_OVERLAY_PATTERN.test(pathname);

  return (
    <PayBillsHubProvider>
      <div
        className={overlayOpen ? 'pointer-events-none select-none opacity-60' : undefined}
        aria-hidden={overlayOpen}
      >
        <PayBills />
      </div>
      <Outlet />
    </PayBillsHubProvider>
  );
};

export default PayBillsLayout;
